export const accountRoutes = [
    {
        path: '/account',
        children: [
            {
                path: 'settings',
                component: () => import(/* webpackChunkName: "account" */ '@/features/account/views/AccountSettings.vue'),
            }
        ]
    }
]
